import { Component, ViewEncapsulation, Input } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { DispatchAssetBus } from '@app/cp/shared/models/DispatchAssetBus';

@Component({
    selector: 'dispatch-assets',
    templateUrl: './dispatch-assets.component.html',
    styleUrls: ['./dispatch-assets.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DispatchAssetsComponent extends BaseGridUIComponent<DispatchAssetBus, null, DispatchesService>  {

    constructor(svc_data: DispatchesService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
    }
    @Input() AppMode: any = "0";
    get groupable(): any {
        return this.AppMode === 1 ? false : "{ showFooter: true }";
    }

}
